<template>
  <div
    class="teaser-collection-block__media"
    :class="[layoutClass, {
      'row-noGutter-equalHeight': isLayout.mainLeft,
      'row-noGutter-column': isLayout.mainTop,
    }]"
  >
    <div
      v-if="isLayout.mainLeft || isLayout.mainTop"
      class="teaser-collection-block__media__main-area"
      :class="{
        'row-noGutter col-8': isLayout.mainLeft && $root.isSmallViewport,
        'row-noGutter col-9': isLayout.mainLeft && !$root.isSmallViewport,
        'row-noGutter col': isLayout.mainTop,
      }"
    >
      <epi-picture
        class="col"
        :image="imageOne"
        :sizes="dimensions"
        :sharpen="80"
        auto-quality="best"
        :use-picture="false"
        :aspect-ratio="aspectRatio"
        :auto-aspect-ratio="!!aspectRatio"
      />
    </div>
    <div
      class="teaser-collection-block__media__secondary-area"
      :class="{
        'row-column-noGutter col-4': isLayout.mainLeft && $root.isSmallViewport,
        'row-column-noGutter col-3': isLayout.mainLeft && !$root.isSmallViewport,
        'row-3-noGutter col': isLayout.mainTop,
        'row-2-noGutter': isLayout.secondaryGrid,
        'row-4-noGutter': isLayout.secondaryRow,

      }"
    >
      <epi-picture
        v-if="isLayout.secondaryGrid || isLayout.secondaryRow"
        class="col"
        :image="imageOne"
        :sizes="dimensions"
        :sharpen="80"
        auto-quality="best"
        :use-picture="false"
        :aspect-ratio="aspectRatio"
        :auto-aspect-ratio="!!aspectRatio"
      />
      <epi-picture
        class="col"
        :image="imageTwo"
        :sizes="dimensions"
        :sharpen="80"
        auto-quality="best"
        :use-picture="false"
        :aspect-ratio="aspectRatio"
        :auto-aspect-ratio="!!aspectRatio"
      />
      <epi-picture
        class="col"
        :image="imageThree"
        :sizes="dimensions"
        :sharpen="80"
        auto-quality="best"
        :use-picture="false"
        :aspect-ratio="aspectRatio"
        :auto-aspect-ratio="!!aspectRatio"
      />
      <epi-picture
        class="col"
        :class="aspectRatio"
        :image="imageFour"
        :sizes="dimensions"
        :sharpen="80"
        auto-quality="best"
        :use-picture="false"
        :aspect-ratio="aspectRatio"
        :auto-aspect-ratio="!!aspectRatio"
      />
    </div>
  </div>
</template>

<script>
const layoutTypes = {
  mainTop: 'mainTop',
  mainLeft: 'mainLeft',
  secondaryRow: 'secondaryRow',
  secondaryGrid: 'secondaryGrid'
}

export default {
  name: "TeaserCollectionBlockImages",
  props: {
    size: {
      type: String,
      default: 'quarter',
      validator: (value) => ['full', 'half', 'third', 'quarter'].includes(value)
    },
    isHighlight:{
      type: Boolean,
      default: false
    },
   imageOne: {
      type: Object,
      default: () => {}
    },
    imageTwo: {
      type: Object,
      default: () => {}
    },
    imageThree: {
      type: Object,
      default: () => {}
    },
    imageFour: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      dimensions: {
        small: {
          width: 767
        },
        medium: {
          width: 480
        },
        large: {
          width: 570
        }
      },
    }
  },
  computed: {
    isSize (){
      return {
        [this.size]: true
      }
    },
    aspectRatio () {
      return this.isLayout.secondaryGrid && this.$root.currentSizeLte('md') ? 100 : 0
    },
    isLayout (){
      return {
        [this.layoutType]: true
      }
    },
    layoutType (){
      switch(this.$root.currentSize) {
        case 'sm':
        case 'xs':
        case 'xxs':
          return this.isHighlight ? layoutTypes.mainLeft : layoutTypes.secondaryGrid
        case 'md':
          return this.isHighlight ? layoutTypes.mainTop : layoutTypes.secondaryRow
        case 'lg':
          return this.isSize.half ? layoutTypes.mainLeft : layoutTypes.mainTop
        case 'xl':
          return this.isSize.quarter ? layoutTypes.mainTop : layoutTypes.mainLeft
      }
      return layoutTypes.mainTop
    },
    layoutClass (){
      return `teaser-collection-block__media--${this.$options.filters.kebab(this.layoutType)}`
    }
  }
}
</script>


<style lang="scss">
.teaser-collection-block__media {
  $this: &;

  height: 100%;
  padding: 4px;

  .epi-picture > div {
    border-radius: 4px;
  }

  .epi-background-container {
    padding-bottom: 0;
  }

  & &__secondary-area > .epi-picture.col,
  & &__main-area > .epi-picture.col {
    padding: 4px;
  }

  &--secondary-grid #{$this}__secondary-area {
    padding: 2px;

    > .epi-picture.col {
      padding: 2px;
    }
  }

  &--secondary-row {
    #{$this}__secondary-area {
      padding: 0;

      .epi-picture {
        padding: 4px;
        height: 5.75rem;
      }
    }
  }

  &--main-left {
    #{$this}__main-area {
      flex-grow: 1;
    }
  }

  &--main-top {
    #{$this}__main-area {
      flex-grow: 3;
      width: 100%;
    }

    #{$this}__secondary-area {
      flex-grow: 1;
      width: 100%;
    }
  }
}
</style>
